var map = {
	"./Image_1.jpg": 6929,
	"./Image_2.jpg": 6307,
	"./Image_3.jpg": 1343,
	"./Image_4.jpg": 5364,
	"./Image_5.jpg": 5004,
	"./Image_6.jpg": 2777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2839;